import { Add } from "@mui/icons-material";
import { Box, Button, Container, Tab } from "@mui/material";
import React, { useState } from "react";
import HistoryAccount from "./HistoryAccount";
import PendingAccount from "./PendingAccount";
import ViewAccount from "./ViewAccount";
import HeaderHelpPage from "../HeaderHelpPage";
import { writeLog } from "../../services/services";
import TabsMenu from "../TabsMenu";
import { TabPanel } from "@mui/lab";
import CreateNewAccount from "../../pages/Admin/CreateNewAccount";
import { styles } from "../../utils/styles";

const AccountSwitchView = ({ userRole }) => {
  const [selectedView, setSelectedView] = useState("All");
  const [createDialog, setCreateDialog] = useState(false);

  const handleChange = (event, value) => {
    setSelectedView(value);
  };
  return (
    <Container>
      <HeaderHelpPage title="Admin User" description="This page manages user access to the Admin portal." />
      <TabsMenu value={selectedView} onChange={handleChange}>
        <Tab label="All" value="All" />
        <Tab label="Pending" value="Pending" />
        <Tab label="History" value="History" />
        {userRole.includes("Add") && selectedView === "All" && (
          <Box>
            <Button
              variant="contained"
              onClick={() => {
                writeLog('[Info] - Click button [Add new account] - Open new tab to create account')
                setCreateDialog(true)
              }}
              startIcon={<Add />}
              sx={{ ...styles.customButton }}
            >
              Add New Account
            </Button>
          </Box>
        )}
        
        <TabPanel value="All">
          <ViewAccount userRole={userRole} />
        </TabPanel>
        <TabPanel value="Pending">
          <PendingAccount userRole={userRole} />
        </TabPanel>
        <TabPanel value="History">
          <HistoryAccount userRole={userRole} />
        </TabPanel>
      </TabsMenu>

      {createDialog && <CreateNewAccount open={true} onClose={() => setCreateDialog(false)} />}
    </Container>
  );
};

export default AccountSwitchView;
